<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>email_outline</mat-icon>
        <div>
          <span>Cartas Inscritos • </span>
          <span>{{title}}</span>
        </div>
      </div>
    </mat-toolbar>
  </mat-card>

  <mat-card>

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>email_outline</mat-icon>
          <div style='color:rgb(43,54,123)'>Cartas</div>
        </ng-template>

        <!-- TABLE -->
        <mat-table class="mat-table-letters" [dataSource]="lettersSubscribersDataSource" matSort matSortActive="name"
          matSortDirection='asc' matSortDisableClear=true>

          <!-- name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Carta </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
          </ng-container>

          <!-- tipo Column -->
          <ng-container matColumnDef="_type">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span *ngIf="element.type==='0'">Requer interação</span>
              <span *ngIf="element.type==='1'">Apenas comunica</span>
            </mat-cell>
          </ng-container>

          <!-- edit Column -->
          <ng-container matColumnDef="edit">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='openLetterSubscribersDialog(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-info' style='font-size:1.5em;'>
                  info_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- delete Column -->
          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef>
              <a mat-button (click)="openLetterSubscribersDialog(null)" style='width:60px;'>
                <mat-icon color='primary'>add_circle_outline</mat-icon>
              </a>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <a mat-button (click)='deleteLetterSubscriber(element)' style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>


          <!-- Header -->
          <mat-header-row *matHeaderRowDef="displayLettersSubscribersColumns; sticky: true;"></mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: displayLettersSubscribersColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style='color:rgb(43,54,123)' class='tab-icon'>forward_to_inbox</mat-icon>
          <div style='color:rgb(43,54,123)'>Inscritos</div>
        </ng-template>
        <div class="select-wrapper">
          <div class="select">
            <mat-select (ngModelChange)='letterSubscriberSelectedChange($event)' [ngModel]="letterSubscriberSelected"
              placeholder="Cartas" *ngIf="lettersSubscribersDataSource">
              <mat-option *ngFor="let reg of arrayLettersSubscribers" [value]="reg.id">
                {{ reg.name }}
              </mat-option>
            </mat-select>
          </div>

          <div style="margin-top: 10px;">
            <button mat-raised-button (click)="exportToCSV()" matTooltip="Exportar CSV">
              <mat-icon>arrow_circle_up</mat-icon>
            </button>
          </div>

        </div>

        <mat-table class="mat-table-subscribers" [dataSource]="_subscriptionsService.subscriptionLetterDataSource">

          <!-- icon Column -->
          <ng-container matColumnDef="icon">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>noise_control_off</mat-icon>
            </mat-cell>
          </ng-container>

          <!-- Member Column -->
          <ng-container matColumnDef="member_name">
            <mat-header-cell *matHeaderCellDef> Membro </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: column;">
                <div>
                  {{ element.member_name }}
                </div>
                <div>
                  <i>{{ element.product_name }}</i>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <!-- email Column -->
          <ng-container matColumnDef="member_email">
            <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.member_email }}
            </mat-cell>
          </ng-container>

          <!-- status Column -->
          <ng-container matColumnDef="accept">
            <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div *ngIf="element.refuse">
                  Recusado
                </div>
                <div *ngIf="!element.refuse">
                  Aceito
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sent_date">
            <mat-header-cell *matHeaderCellDef> Envio </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="element.sentDate">
                <a target="_blank" [href]='element.letter_link'>
                  {{ element.sentDate | date: 'dd/MM/yyyy' }}
                </a>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="response_date">
            <mat-header-cell *matHeaderCellDef> Resposta </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div *ngIf="element.responseDate">
                {{ element.responseDate | date: 'dd/MM/yyyy' }}
              </div>
            </mat-cell>
          </ng-container>

          <!-- Selected Column -->
          <ng-container matColumnDef="selected">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-checkbox *ngIf="!element.sentDate" color='primary' [(ngModel)]="element.selected">
              </mat-checkbox>
              <a mat-button *ngIf="element.sentDate" (click)='deleteEmailLetter(element)'
                style='background-color: whitesmoke;'>
                <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                </mat-icon>
              </a>
            </mat-cell>
          </ng-container>

          <!-- Header -->
          <mat-header-row class='mat-header-row'
            *matHeaderRowDef="_subscriptionsService.displayedSubscriptionLetterColumns; sticky: true;">
          </mat-header-row>

          <!-- Row -->
          <mat-row *matRowDef="let row; columns: _subscriptionsService.displayedSubscriptionLetterColumns;">
          </mat-row>

        </mat-table>

        <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
          <button mat-raised-button (click)='sendSubscribersEmail()'>
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
          </button>
        </div>
      </mat-tab>

    </mat-tab-group>

  </mat-card>

</div>